import { api } from '../api/client';
import { normalizeId } from '../utils/ids';
import { offeredQuery } from '../utils/lookupFilter';

/**
 * isOffered({ collectionId, cardId, filter, id }) -> Promise<boolean>
 *
 * Is item `id` one a lookup's picker filter offers? Asked through the list
 * endpoint with the filter ANDed to `id = …` in `?q=` — the compile the API's
 * strict gate shares (keepr-api utils/lookupFilter.js) — over the same scope
 * the picker fetches (`include_descendants`), read as stored text
 * (`q_stored` — the gate's `collection` tag mode). A blank filter offers every
 * item. A failed request answers false: under strict the form never offers
 * what it could not confirm (the save would be refused anyway).
 */
export async function isOffered({ collectionId, cardId, filter, id, signal } = {}) {
	const text = String(filter || '').trim();
	const want = normalizeId(id);
	if (!text) return true;
	if (!want) return false;
	const params = { q: offeredQuery(text, want), q_stored: true, limit: 1, include_descendants: true };
	if (collectionId) params.collection_id = collectionId;
	if (cardId) params.card_id = cardId;
	try {
		const response = await api.get('/items', { params, signal });
		const data = response?.data;
		const rows = Array.isArray(data) ? data : (Array.isArray(data?.items) ? data.items : []);
		return rows.some(row => normalizeId(row?._id) === want);
	} catch (e) {
		return false;
	}
}

export default isOffered;
